// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1l82O","dragIcon":"SortableItem_dragIcon__3cpfE","disabled":"SortableItem_disabled__DZXX-"};